import { lazyWithRetry } from 'components/lazyUtil.js'
const Claims = lazyWithRetry(() => import('../../owners/Claims'))

// IMPORTANT //
// In Future: whenever new route path is added ensure to update "validPaths" in /server/validRoutes.js
const routes = [
  {
    path: '/claims/:uuid/edit',
    component: Claims,
    is_private: true,
  },
]

export default routes